import { Middleware } from 'redux';
import { createLogger, LogEntryObject } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import { isDefined, isDev } from '@hsp/utilities';

const middleware: Middleware[] = [];
const sagaMiddleware = createSagaMiddleware();

if (isDev) {
  const logger = createLogger({
    collapsed: (_getState: () => unknown, _action: unknown, logEntry?: LogEntryObject) => !isDefined(logEntry?.error),
  });

  middleware.push(logger);
}

middleware.push(sagaMiddleware);

export { middleware };
